<template>
  <v-container>
    <v-row flex>
      <v-dialog
        v-model="openBatchReceiptsDialog"
        max-width="500px"
        min-width="200px"
        persistent
      >
        <v-card>
          <v-card-title class="headline"> Renewal Batch Payment </v-card-title>
          <v-card-text>
            <v-list flat subheader three-line>
              <v-subheader>Select invoice(s) you wish to pay</v-subheader>
              <v-list-item-group
                v-model="selected"
                multiple
                active-class="green--text"
              >
                <template v-for="(item, i) in batchedRenewals">
                  <v-divider :key="`divider-${i}`"></v-divider>
                  <v-list-item
                    :key="i"
                    :value="item"
                    active-class="green--text"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2">
                          Applies to {{ item.currentProgrammeCode }} -
                          {{ item.renewalPeriod }}
                          <v-spacer />
                          <span class="font-weight-bold text-body-2">{{
                            item.description
                          }}</span>
                          <span
                            class="font-weight-bold text-body-2"
                            v-if="item.amount !== 0"
                          >
                            {{ item.billedAmount }} {{ currency }}</span
                          >
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          @click="previewInvoice(item.serviceRequest)"
                          color="primary"
                        >
                          invoice
                        </v-btn>
                        <v-checkbox
                          :input-value="active"
                          :disabled="item.amount === 0"
                          color="green"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="openBatchReceiptsDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="setRenewalBatchPayment"
              :disabled="!selected.length"
            >
              proceed to pay
              {{ currency }}
              {{ selected.reduce((cum, cur) => cum + cur.billedAmount, 0) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { initiatePesaflowBatchPayment } from "../../dashboard/environment";
export default {
  name: "BatchPaymentDialogeComponent",
  data() {
    return {
      selected: [],
      initiatePesaflowBatchPayment: JSON.parse(initiatePesaflowBatchPayment),
    };
  },
  mounted() {
    window.document.title = "KISEB::Batch Pay For Renewal";
  },
  computed: {
    batchedRenewals() {
      return this.$store.getters["Renewal/renewalGetters"]("batchRenewal");
    },
    currency: {
      get() {
        return this.$store.getters["Renewal/renewalGetters"]("currency");
      },
      set(value) {
        this.$store.commit("Renewal/MUTATE", {
          state: "currency",
          data: value,
        });
      },
    },
    openBatchReceiptsDialog: {
      get() {
        return this.$store.getters["Renewal/renewalGetters"](
          "openBatchReceiptsDialog",
        );
      },
      set(value) {
        this.$store.commit("Renewal/MUTATE", {
          state: "openBatchReceiptsDialog",
          data: value,
        });
      },
    },
    openIvoiceDialog: {
      get() {
        return this.$store.getters["Renewal/renewalGetters"](
          "openIvoiceDialog",
        );
      },
      set(value) {
        this.$store.commit("Renewal/MUTATE", {
          state: "openIvoiceDialog",
          data: value,
        });
      },
    },
  },
  methods: {
    previewInvoice(item) {
      this.$store.commit("Renewal/MUTATE", {
        state: "renewal_document",
        data: "",
      });
      this.openIvoiceDialog = true;
      this.$store.dispatch("Renewal/getRenewalProforma", item);
    },
    setRenewalBatchPayment() {
      if (this.selected.length < 2) {
        this.$emit("setRenewalBatchPayment", {
          payload: this.selected[0],
          isBatch: false,
        });
      } else {
        this.$emit("setRenewalBatchPayment", {
          payload: this.selected,
          isBatch: true,
        });
      }
    },
  },
};
</script>
